import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unchecked",
  "use": "icon-unchecked-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" class=\"design-iconfont\" id=\"icon-unchecked\">\n  <path stroke=\"#C5CAD5\" d=\"M8 0.5A7.5 7.5 0 1 0 8 15.5A7.5 7.5 0 1 0 8 0.5Z\" fill=\"none\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol